import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

interface ResultContainerProps {
    padding: string;
    align: 'center' | 'normal';
    className?: string;
}

// eslint-disable-next-line rulesdir/no-styled-export
export const ResultContainer = styled.div`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    align-items: ${(props: ResultContainerProps) => props.align};
    justify-content: space-between;
    padding: 0 ${(props: ResultContainerProps) => props.padding};
`;

interface IconContainerProps {
    iconSize: string;
    iconMargin: string;
    right?: boolean;
    isCenterAlignIcon?: boolean;
}
// eslint-disable-next-line rulesdir/no-styled-export
export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props: IconContainerProps) => props.iconSize};
    align-self: flex-start;
    margin-top: ${token('space.050', '4px')};
    flex-shrink: 0;
    ${(props: IconContainerProps) => props.isCenterAlignIcon && `margin: auto`};
    ${(props: IconContainerProps) =>
        props.right ? `margin-left: ${props.iconMargin}` : `margin-right: ${props.iconMargin}`};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const ResultContentContainer = styled.div`
    width: 100%;
    overflow: hidden;
`;
